<template>
  <div class="material-box" :class="source ==='massSend'?'':'setWidth'">
    <div class="material-content">
      <el-tabs v-model="currentMaterialType" id="material-nav" tab-position="top" @tab-click="handleClick">
        <el-tab-pane label="图文" name="NEWS">
          <div class="article-box">
            <div class="article-box-title">
              <el-input placeholder="请输入内容" v-model="articalSearchInput" class="input-with-select" size="mini"
                        @keyup.enter.native="loadMaterialList" @input="valueNull">
                <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
              </el-input>
            </div>
            <div class="article-box-content" :class="source ==='massSend'?'setHeight':''">
              <div class="article-item-add" @click="openMaterialNews">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加素材</span>
              </div>
              <div class="article-item"
                   :class="currentSelectedDiv==item.id&&source ==='massSend'?'article-item-selected':''"
                   v-for="(item,index) in currentMaterialList" :key="index" @click="groupClick(index,'first',item)"
                   @mouseenter="changShowOperation(index)" v-on:mouseleave="changShowOperation()">
                <div class="article-item-image">
                  <el-image
                      style="width: 100%; height: 100px"
                      fit="cover"
                      :src="item.content.cover"
                      v-if="item.content.cover"
                  >

                  </el-image>
                  <div
                      style="
                                                background-color: #F5F7FA;
                                                color: #C0C4CC;
                                                height: 90px;
                                                width: 100%;
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;"
                      v-if="!item.content.cover"
                  >暂无封面
                  </div>
                </div>
                <div class="article-item-title">
                  {{ item.content.title }}
                </div>
                <div class="article-item-desc">
                  {{ item.content.summary }}
                </div>
                <div class="article-item-operation" v-show="showTextOperation === index">
                  <div class="date">{{ new Date(item.updateTime).Format('yyyy-MM-dd') }}</div>
                  <div class="button">
                    <i class="el-icon-view" @click="copeUrl(item.content.url,item)"></i>
                    <i class="el-icon-edit" @click="openarticleDrawer(item)" v-if="source==='material'"></i>
                    <i class="el-icon-delete" @click="deleteMateria(item.id,'link')" v-if="source==='material'"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="外链图文" name="LINK_NEWS">
          <div class="article-box">
            <div class="article-box-title">
              <el-input placeholder="请输入内容" v-model="articalSearchInput" class="input-with-select" size="small"
                        @keyup.enter.native="loadMaterialList" @input="valueNull">
                <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
              </el-input>
            </div>
            <div class="article-box-content" :class="source ==='massSend'?'setHeight':''">
              <div class="article-item-add" @click="openMaterialNewsLink">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加素材</span>
              </div>
              <div class="article-item"
                   :class="currentSelectedDiv==item.id&&source ==='massSend'?'article-item-selected':''"
                   v-for="(item,index) in currentMaterialList" :key="index" @click="groupClick(index,'first',item)"
                   @mouseenter="changShowOperation(index)" v-on:mouseleave="changShowOperation()">
                <div class="article-item-image">
                  <el-image
                      style="width: 100%; height: 100px"
                      fit="cover"
                      :src="item.content.cover"
                       v-if="item.content.cover"></el-image>
                  <div
                      style="
                                                background-color: #F5F7FA;
                                                color: #C0C4CC;
                                                height: 90px;
                                                width: 100%;
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;"
                      v-if="!item.content.cover"
                  >暂无封面
                  </div>
                </div>
                <div class="article-item-title">
                  {{ item.content.title }}
                </div>
                <div class="article-item-desc">
                  {{ item.content.summary }}
                </div>
                <div class="article-item-operation" v-show="showTextOperation === index">
                  <div class="date">{{ new Date(item.updateTime).Format('yyyy-MM-dd') }}</div>
                  <div class="button">
                    <i class="el-icon-view" @click="copeLinkUrl(item.content.url,item)"></i>
                    <i class="el-icon-edit" @click="openMaterialNewsLinkDrawer(item)" v-if="source==='material'"></i>
                    <i class="el-icon-delete" @click="deleteMateria(item.id,'linknews')" v-if="source==='material'"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="文字" name="TEXT">
          <div class="text-box">
            <div class="text-box-title">
              <el-input placeholder="请输入内容" v-model="articalSearchInput" class="input-with-select" size="mini"
                        @keyup.enter.native="loadMaterialList" @input="valueNull">
                <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
              </el-input>
            </div>
            <div class="text-box-content" :class="source ==='massSend'?'setHeight':''">
              <div class="text-item-add" @click="openTextDialog">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加素材</span>
              </div>
              <div class="text-item"
                   :class="currentSelectedDiv==item.id  &&source ==='massSend'?'text-item-selected':''"
                   @click="groupClick(index,'second',item)" v-for="(item,index) in currentMaterialList"
                   :key="index" @mouseenter="changShowOperation(index)" v-on:mouseleave="changShowOperation()">
                <div class="text-item-title">
                  {{ item.content.content }}
                </div>
                <div class="text-item-operation" v-show="showTextOperation === index&&source==='material'">
                  <div class="date">{{ new Date(item.updateTime).Format('yyyy-MM-dd') }}</div>
                  <div class="button">
                    <i class="el-icon-copy-document" @click="doCopy(item.content.content)"></i>
                    <i class="el-icon-edit" @click="openMaterialText(item,'text')"></i>
                    <i class="el-icon-delete" @click="deleteMateria(item.id,'text')"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="图片" name="IMAGE">
          <div class="picture-box">
            <div class="picture-box-title">
              <el-input placeholder="请输入内容" v-model="articalSearchInput" class="input-with-select" size="mini"
                        @keyup.enter.native="loadMaterialList" @input="valueNull">
                <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
              </el-input>
            </div>
            <div class="picture-box-content" :class="source ==='massSend'?'setHeight':''">
              <div class="picture-item-add" @click="openPictureDialog ">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加素材</span>
              </div>
              <div class="picture-item"
                   :class="currentSelectedDiv==item.id  &&source ==='massSend' ?'picture-item-selected':''"
                   @click="groupClick(index,'third',item)" v-for="(item,index) in currentMaterialList"
                   :key="index" @mouseenter="changShowOperation(index)" v-on:mouseleave="changShowOperation()">
                <div class="picture-item-image">
                  <!-- <el-image
                                         style="width: auto;height:200px"
                                         fit="cover"
                                         :preview-src-list="[item.content.url]"
                                         :src="item.content.url"></el-image>-->

                  <img
                      style="width: 200px;height: 200px;object-fit: contain"
                      :src="item.content.url"
                  />

                </div>
                <div class="picture-item-name" v-show="showTextOperation !== index">{{ item.content.name }}</div>
                <div class="picture-item-operation" v-show="showTextOperation === index">
                  <div class="date">{{ new Date(item.updateTime).Format('yyyy-MM-dd') }}</div>
                  <div class="button">
                    <i class="el-icon-view" @click="viewImage(item)"></i>
                    <el-link
                        :href="item.content.url" target="_blank"
                        :underline="false"
                        v-if="source==='material'"
                    ><i class="el-icon-download"></i></el-link>
                    <i
                        class="el-icon-edit"
                        @click="openMaterialText(item,'image')"
                        v-if="source==='material'"
                    ></i>
                    <i
                        class="el-icon-delete"
                        @click="deleteMateria(item.id,'image')"
                        v-if="source==='material'"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="视频" name="VIDEO">
          <div class="picture-box">
            <div class="picture-box-title">
              <el-input placeholder="请输入内容" v-model="articalSearchInput" class="input-with-select" size="mini"
                        @keyup.enter.native="loadMaterialList" @input="valueNull">
                <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
              </el-input>
            </div>
            <div class="picture-box-content" :class="source ==='massSend'?'setHeight':''">
              <div class="picture-item-add" @click="openVideoDialog">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加素材</span>
              </div>
              <div class="picture-item"
                   :class="currentSelectedDiv==item.id &&source ==='massSend'?'picture-item-selected':''"
                   @click="groupClick(index,'fourth',item)" v-for="(item,index) in currentMaterialList" :key="index"
                   @mouseenter="changShowOperation(index)" v-on:mouseleave="changShowOperation()">
                <div class="picture-item-image"
                     style="display:flex;flex-direction: column;align-items: center;justify-content: center;background-color:#f0f4fc;height:200px">
                  <!-- <video :src="item.content.url" controls class="video"
                                        width="100%" height="270" style="margin-top:-79px"></video> -->
                  <el-dialog
                      title :visible.sync="dialogPlay"
                      width="30%"
                      @close="closeDialog"
                      append-to-body
                  >
                    <video :src="videoUrl" controls autoplay class="video"
                           width="100%"></video>
                  </el-dialog>
                  <em class="el-icon-video-play" style="font-size:36px;color:#409eff;cursor: pointer;"
                      @click="playVideo(item.content.url)"></em>
                </div>
                <div class="picture-item-name" v-show="showTextOperation != index||source!=='material'">
                  {{ item.content.name }}
                </div>
                <div class="picture-item-operation" v-show="showTextOperation === index&&source==='material'">
                  <div class="date">{{ new Date(item.updateTime).Format('yyyy-MM-dd') }}</div>
                  <div class="button">
                    <el-link :href="item.content.url" target="_blank" :underline="false"><i
                        class="el-icon-download"></i></el-link>
                    <i class="el-icon-edit" @click="openMaterialText(item,'video')"></i>
                    <i class="el-icon-delete" @click="deleteMateria(item.id,'video')"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
<!--        <el-tab-pane label="文件" name="FILE" v-if="source==='material'">
          <div class="picture-box">
            <div class="picture-box-title">
              <el-input placeholder="请输入内容" v-model="articalSearchInput" class="input-with-select" size="mini"
                        @keyup.enter.native="loadMaterialList" @input="valueNull">
                <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
              </el-input>
            </div>
            <div class="picture-box-content" :class="source ==='massSend'?'setHeight':''">
              <div class="picture-item-add" @click=" openFileDialog">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加素材</span>
              </div>
              <div class="picture-item"
                   :class="currentSelectedDiv==item.id &&source ==='massSend'?'picture-item-selected':''"
                   @click="groupClick(index,'sixth',item)" v-for="(item,index) in currentMaterialList" :key="index"
                   @mouseenter="changShowOperation(index)" v-on:mouseleave="changShowOperation()">
                <div class="picture-item-image">
                  <el-image
                      style="width: auto;height:200px"
                      fit="fill"
                      src="https://guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com/cdn-office-website/scrm/preview-img.jpg"></el-image>
                </div>
                <div class="picture-item-name" v-show="(showTextOperation != index)">{{ item.content.name }}</div>
                <div class="picture-item-operation" v-show="showTextOperation === index">
                  <div class="date">{{ new Date(item.updateTime).Format('yyyy-MM-dd') }}</div>
                  <div class="button">
                    <el-link :href="item.content.url" target="_blank" :underline="false"><i
                        class="el-icon-download"></i></el-link>
                    <i
                        class="el-icon-edit"
                        @click="openMaterialText(item,'file')"
                        v-if="source==='material'"
                    ></i>
                    <i
                        class="el-icon-delete"
                        @click="deleteMateria(item.id,'file')"
                        v-if="source==='material'"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="音频" name="VOICE" v-if="source==='material'">
          <div class="picture-box">
            <div class="picture-box-title">
              <el-input placeholder="请输入内容" v-model="articalSearchInput" class="input-with-select" size="mini"
                        @keyup.enter.native="loadMaterialList" @input="valueNull">
                <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
              </el-input>
            </div>
            <div class="picture-box-content" :class="source ==='massSend'?'setHeight':''">
              <div class="picture-item-add" @click="openVoiceDialog ">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加素材</span>
              </div>
              <div class="picture-item"
                   :class="currentSelectedDiv==item.id &&source ==='massSend'?'picture-item-selected':''"
                   @click="groupClick(index,'seventh',item)" v-for="(item,index) in currentMaterialList" :key="index"
                   @mouseenter="changShowOperation(index)"
                   v-on:mouseleave="changShowOperation()">
                <div class="picture-item-image"
                     style="display:flex;flex-direction: column;align-items: center;justify-content: center;background-color:#f0f4fc;height:200px">
                  <em :id="index +'play'"
                      class="el-icon-video-play"
                      style="font-size:36px;color:#409eff;cursor: pointer;"
                      @click="listenAudio(index)"

                  ></em>
                  <em
                      :id="index +'stop'"
                      class="el-icon-video-pause"
                      style="display:none;font-size:36px;color:#409eff;cursor: pointer;"
                      @click="stopAudio(index)"
                  ></em>
                </div>
                <div class="picture-item-name" style="margin-top:10px"
                     v-show="(showTextOperation != index || source!=='material')">{{ item.content.name }}
                </div>
                <div class="picture-item-operation" v-show="showTextOperation === index&&source==='material'">
                  <div class="date">{{ item.updatetime }}</div>
                  <div class="button">
                    <el-link :href="item.content.url" target="_blank" :underline="false"><i
                        class="el-icon-download"></i></el-link>
                    <i class="el-icon-edit" @click="openMaterialText(item,'voice')"></i>
                    <i class="el-icon-delete" @click="deleteMateria(item.id,'voice')"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>-->
      </el-tabs>
    </div>
    <!-- 图文信息编辑抽屉 -->
    <el-drawer
        :title="addMaterialTitle"
        :visible.sync="articleDrawer"
        direction="rtl"
        size="70%"
        ref="drawer"
        :modal="false"
        :wrapperClosable="false"
    >
      <div class="template-config">
        <div class="template-config-box">
          <div class="template-config-title">
            <div class="title-text">
              <el-input
                  type="text"
                  placeholder="请输入标题"
                  v-model="currentMaterialNews.content.title"
                  maxlength="40"
                  show-word-limit
              ></el-input>
            </div>
            <div class="author">
              <el-input
                  type="text"
                  placeholder="作者"
                  v-model="currentMaterialNews.content.author"
                  maxlength="10"
                  show-word-limit
              ></el-input>
            </div>
          </div>
          <div class="template-config-content">
            <ckeditor
                :editor="ckeditor.editor"
                v-model="currentMaterialNews.content.content"
                :config="editorConfig"
            ></ckeditor>
          </div>
          <div class="template-config-other">
            <div class="image">
              <el-upload
                  action="guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com"
                  :multiple="false"
                  :limit="1"
                  list-type="text"
                  :file-list="fileList"
                  accept=".jpg,.png"
                  :on-remove="(file,fileList)=>currentMaterialNews.content.cover=''"
                  :http-request="aliyunOssRequestMaterialNews"
                  :on-success="imageFileUpload"
                  :on-change="handleChangePic"
                  :on-preview="(file)=>dialogImageUrl=file.url"
                  style="display: flex;justify-content: center;align-items: center;"

              >
                <div>
                  <div :style="currentMaterialNews.content.cover===''?'width:40vw':'width:80px'"
                       style="margin-right: 16px;flex: none">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <span v-if="currentMaterialNews.content.cover===''">添加封面</span>
                    <span v-else>重新上传</span>
                  </div>
                </div>

              </el-upload>
            </div>
            <div class="desc">
              <el-input
                  type="textarea"
                  placeholder="请输入文章描述"
                  v-model="currentMaterialNews.content.summary"
                  maxlength="60"
                  show-word-limit
              ></el-input>
            </div>
          </div>

        </div>
        <div class="template-preview">
          <template>
            <el-tabs v-model="previewActiveName" id="material-right">
              <el-tab-pane label="消息推送预览" name="first">
                <div class="template-preview-content">
                  <div class="template-preview-article-title">
                    <i class="el-icon-arrow-left"></i>
                    <span>果然私域AI助手</span>
                    <i class="el-icon-s-custom"></i>
                  </div>
                  <div class="template-preview-message-content">
                    <div class="push-message-box">
                      <div class="image">
                        <el-image
                            style="width:100%;height:120px"
                            :src="currentMaterialNews.content.cover"
                            fit="cover"
                            v-if="currentMaterialNews.content.cover!==''"
                        ></el-image>
                        <div
                            style="
                                                background-color: #F5F7FA;
                                                color: #C0C4CC;
                                                height: 90px;
                                                width: 100%;
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;"
                            v-if="currentMaterialNews.content.cover===''"
                        >暂无封面
                        </div>
                      </div>
                      <div class="title">
                        {{ currentMaterialNews.content.title }}
                      </div>
                      <div class="desc">
                        {{ currentMaterialNews.content.summary }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="消息详情预览" name="second">
                <div class="template-preview-content">
                  <div class="template-preview-article-title">
                    <i class="el-icon-close"></i>
                    <span>{{ currentMaterialNews.content.title }}</span>
                    <i class="el-icon-more"></i>
                  </div>
                  <div class="template-preview-article-content">
                    <div class="article-content-title">
                      {{ currentMaterialNews.content.title }}
                    </div>
                    <div class="article-content-author">
                      <span>{{ currentMaterialNews.content.author }}</span>
                      <span>{{ articelAddDate }}</span>
                    </div>
                    <div class="article-content-body">
                      <p v-html="currentMaterialNews.content.content"></p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
      <div class="article-template-footer">
        <el-button @click="articleDrawer = false">取 消</el-button>
        <el-button type="primary" @click="saveCurrentNews">提交</el-button>
      </div>
    </el-drawer>
    <!--外链图文抽屉-->
    <el-drawer
        :title="addMaterialTitle"
        :visible.sync="articleLinkDrawer"
        direction="rtl"
        size="70%"
        ref="drawer"
        :modal="false"
        :wrapperClosable="false"
    >
      <div class="template-config">
        <div class="template-config-box">
          <div class="template-config-title">
            <div class="link-title-text">
              <el-input
                  type="text"
                  placeholder="请输入标题"
                  v-model="currentMaterialLinkNews.content.title"
                  maxlength="40"
                  show-word-limit
              ></el-input>
            </div>
            <!--<div class="author">
                            <el-input
                                    type="text"
                                    placeholder="作者"
                                    v-model="currentMaterialNews.content.author"
                                    maxlength="10"
                                    show-word-limit
                            ></el-input>
                        </div>-->
          </div>
          <div class="template-link">
            <el-input
                type="text"
                placeholder="请输入合法的消息链接"
                v-model="currentMaterialLinkNews.content.url"
            ></el-input>
          </div>
          <div class="template-config-other">
            <div class="image">
              <el-upload
                  action="/api/oss/public?token=8c98087dfd2d48f856d8c95c09115def"
                  list-type="text"
                  :file-list="fileList"
                  accept=".jpg,.png"
                  :on-remove="(file,fileList)=>currentMaterialLinkNews.content.cover=''"
                  :on-success="imageLinkUpload"
                  :on-change="handleChangePic"
                  :http-request="aliyunOssRequestMaterialNews"
                  :on-preview="(file)=>dialogImageUrl=file.url"
                  style="display: flex;justify-content: center;align-items: center;"
              >
                <div>
                  <div :style="currentMaterialLinkNews.content.cover===''?'width:40vw':'width:80px'"
                       style="margin-right: 16px;flex: none">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <span v-if="currentMaterialLinkNews.content.cover===''">添加封面</span>
                    <span v-else>重新上传</span>
                  </div>
                </div>
              </el-upload>
            </div>
            <div class="desc">
              <el-input
                  type="textarea"
                  placeholder="请输入文章描述"
                  v-model="currentMaterialLinkNews.content.summary"
                  maxlength="60"
                  show-word-limit
              ></el-input>
            </div>
          </div>

        </div>
        <div class="template-preview">
          <template>
            <el-tabs v-model="previewActiveName" id="material-right-link">
              <el-tab-pane label="消息推送预览" name="first">
                <div class="template-preview-content">
                  <div class="template-preview-article-title">
                    <i class="el-icon-arrow-left"></i>
                    <span>果然SCRM</span>
                    <i class="el-icon-s-custom"></i>
                  </div>
                  <div class="template-preview-message-content">
                    <div class="push-message-box">
                      <div class="image">
                        <el-image
                            style="width:100%;height:120px"
                            :src="currentMaterialLinkNews.content.cover"
                            fit="cover"
                            v-if="currentMaterialLinkNews.content.cover!==''"
                        ></el-image>
                        <div
                            style="
                                                background-color: #F5F7FA;
                                                color: #C0C4CC;
                                                height: 90px;
                                                width: 100%;
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;"
                            v-if="currentMaterialLinkNews.content.cover===''"
                        >暂无封面
                        </div>
                      </div>
                      <div class="title">
                        {{ currentMaterialLinkNews.content.title }}
                      </div>
                      <div class="desc">
                        {{ currentMaterialLinkNews.content.summary }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
      <div class="article-template-footer">
        <el-button @click="articleLinkDrawer = false">取 消</el-button>
        <el-button type="primary" @click="saveCurrentNewsLink">提交</el-button>
      </div>
    </el-drawer>
    <!-- 添加文本素材 -->
    <el-dialog
        :title="materialTitle"
        :visible.sync="textDialogVisible"
        :close-on-click-modal="false"
        append-to-body
        width="30%">
      <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="currentMaterialText.content.content"
          rows="5"
          maxlength="100"
          show-word-limit
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
            <el-button @click="textDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveCurrentText">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 添加图片素材 -->
    <el-dialog
        :title="materialTitle"
        :visible.sync="pictureDialogVisible"
        :close-on-click-modal="false"
        append-to-body
        class="addImage"
        width="30%"

    >
      <div v-loading="loadingUpload">
        <el-form label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="currentMaterialImage.content.name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="图片">
            <!-- <el-upload
                action="guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com"
                list-type="picture-card"
                :show-file-list="false"
                :on-preview="handlePictureCardPreview"
                :http-request="aliyunOssRequest"
                :on-success="(res)=>currentMaterialImage.content.url=res.url"
                :on-remove="(file)=>currentMaterialImage.content.url=''">
                    <img v-if="currentMaterialImage.content.url"
                    :src="currentMaterialImage.content.url" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
            <el-upload
                action="guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com"
                :http-request="aliyunOssRequestMaterialNews"
                :on-success="pictureUploadSuccess"
                list-type="text"
                :limit="1"
                accept=".jpg,.png"
                :file-list="fileList"
                :on-remove="handleRemove"
                ref="my-upload"
            >
              <!-- <div v-if="currentMaterialImage.content.url" class="file-list-box">
                       <div class="file-name">
                           {{currentMaterialImage.content.name}}
                       </div>
                       <div class="file-status">
                           <i style="color:green" class="el-icon-circle-check"></i>
                       </div>
                   </div>-->
              <el-button v-if="showUploadBtn" type="primary">上传文件<i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="pictureDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveCurrentImage">确 定</el-button>
        </span>
      </div>

    </el-dialog>

    <!-- 调加视频素材 -->
    <el-dialog
        :title="materialTitle"
        :visible.sync="videoDialogVisible"
        :close-on-click-modal="false"
        append-to-body
        class="addImage"
        width="30%">
      <div v-loading="loadingUpload">
        <el-form label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="currentMaterialVideo.content.name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="视频">
            <!-- <el-upload
                action="guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com"
                :show-file-list="false"
                :http-request="aliyunOssRequest"
                :on-success="(res)=>currentMaterialVideo.content.url=res.url"
                >
                    <video v-if="currentMaterialVideo.content.url" width="200px"
                    :src="currentMaterialVideo.content.url" class="avatar"></video>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
            <el-upload
                action="guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com"
                :http-request="aliyunOssRequestVideo"
                :on-success="videoUploadSuccess"
                list-type="text"
                :limit="1"
                accept=".mp4"
                :on-remove="handleRemove"
                :file-list="fileList"
            >
              <!-- <div v-if="currentMaterialVideo.content.url" class="file-list-box">
                       <div class="file-name">
                           {{currentMaterialVideo.content.name}}
                       </div>
                       <div class="file-status">
                           <i style="color:green" class="el-icon-circle-check"></i>
                       </div>
                   </div>-->
              <el-button v-if="showUploadBtn" type="primary">上传文件<i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
              <el-button @click="videoDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveCurrentVideo">确 定</el-button>
            </span>
      </div>

    </el-dialog>

    <!-- 调加文件素材 -->
    <el-dialog
        :title="materialTitle"
        :visible.sync="fileDialogVisible"
        :close-on-click-modal="false"
        class="addImage"
        append-to-body
        width="30%">
      <div v-loading="loadingUpload">
        <el-form label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="currentMaterialFile.content.name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="文件">
            <el-upload
                action="guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com"
                :http-request="aliyunOssRequest"
                :on-success="fileUploadSuccess"
                list-type="text"
                :limit="1"
                :on-remove="handleRemove"
                :file-list="fileList"
            >
              <!--<div v-if="currentMaterialFile.content.url" class="file-list-box">
                      <div class="file-name">
                          {{currentMaterialFile.content.name}}
                      </div>
                      <div class="file-status">
                          <i style="color:green" class="el-icon-circle-check"></i>
                      </div>
                  </div>-->
              <el-button v-if="showUploadBtn" type="primary">上传文件<i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
              <el-button @click="fileDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveCurrentFile">确 定</el-button>
            </span>
      </div>

    </el-dialog>

    <!-- 调加音频素材 -->
    <el-dialog
        :title="materialTitle"
        :visible.sync="voiceDialogVisible"
        :close-on-click-modal="false"
        class="addImage"
        append-to-body
        width="30%">
      <div v-loading="loadingUpload">
        <el-form label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="currentMaterialVoice.content.name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="音频文件">
            <el-upload
                action="guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com"
                :http-request="aliyunOssRequestVoice"
                :on-success="voiceUploadSuccess"
                list-type="text"
                :limit="1"
                accept=".amr,.mp3"
                :on-remove="handleRemove"
                :file-list="fileList"
            >
              <!--<div v-if="currentMaterialVoice.content.url" class="file-list-box">
                      <div class="file-name">
                          {{currentMaterialVoice.content.name}}
                      </div>
                      <div class="file-status">
                          <i style="color:green" class="el-icon-circle-check"></i>
                      </div>
                  </div>-->
              <el-button v-if="showUploadBtn" type="primary">上传音频文件<i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
              <el-button @click="voiceDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveCurrentVoice">确 定</el-button>
            </span>
      </div>

    </el-dialog>


    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <div
        v-if="showPreview"
        style="
        width: 100vw;
        height: 100vh;
        z-index: 10000;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
      "
    >
      <div
          @click="showPreview = false"
          style="
          color: white;
          font-size: 30px;
          padding: 30px 30px 15vh;
          text-align: right;
          cursor: pointer;
        "
      >
        X
      </div>
      <div style="display: flex;justify-content: center;align-items: center">
        <img
            style="max-height: 70vh; max-width: 70vw"
            :src="previewImageUrl"
            alt
            srcset
        />
      </div>

    </div>
  </div>
</template>

<script>

import {upload, ossFileUrl, ossConfig} from '../utils/AliyunlssUtil';
import Clipboard from 'clipboard';
import {MyCustomUploadAdapterPlugin} from '../assets/js/ckeditor'
import CKEDITOR from "ckeditor";

export default {
  components: {
    Clipboard
  },
  data() {
    return {
      //当前选择的素材类型
      currentMaterialType: 'NEWS',
      // 当前素材列表
      currentMaterialList: [],
      // 搜索关键字
      searchKeywords: '',
      ckeditor: {
        editor: CKEDITOR.ClassicEditor
      },
      // 当前图文素材
      currentMaterialNews: {
        id: '',
        content: {
          author: "",
          content: "",
          cover: "",
          ext: {},
          summary: "",
          title: "",
          coverSize: ''
        }
      },
      currentMaterialLinkNews: {
        id: '',
        content: {
          author: "",
          cover: "",
          coverSize: 0,
          summary: "",
          title: "",
          url: ''
        }
      },
      // 当前文本素材
      currentMaterialText: {
        id: '',
        content: {
          content: ''
        }
      },
      currentMaterialImage: {
        id: '',
        content: {
          name: '',
          url: '',
          size: 0,
          ext: {}
        }
      },
      videoDialogVisible: false,
      currentMaterialVideo: {
        id: '',
        content: {
          name: '',
          url: '',
          description: '',
          size: 0,
          ext: {},
          cover: ''
        }
      },
      fileDialogVisible: false,
      currentMaterialFile: {
        id: '',
        content: {
          name: '',
          url: '',
          size: 0
        }
      },
      voiceDialogVisible: false,
      currentMaterialVoice: {
        id: '',
        content: {
          name: '',
          url: '',
          description: '',
          size: 0
        }
      },
      voiceFileList: [],
      articalSearchInput: '',
      isShowOperation: false,
      articleDrawer: false,
      articleTitleText: '',
      articleAuthor: '',
      articleDesc: '',
      articleBody: '',
      articelAddDate: '',
      previewActiveName: 'first',
      textDialogVisible: false,
      textarea: '',
      srcList: [
        'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
      ],
      isShowPictrueName: true,
      pictureDialogVisible: false,
      pictureForm: {
        name: '',
        pictureUrl: '',
      },
      videoUrl: 'https://v-cdn.zjol.com.cn/276991.mp4',
      dialogPlay: false,
      textList: [],
      showTextOperation: 'null',
      articleList: [],
      pictureList: [],
      videoList: [],
      fileList: [],
      audioList: [],
      palyingAudioUrl: '', //音频素材URL
      playingStutus: false, //音频播放状态
      dialogImageUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg', //图文素材缩略图上传URL
      dialogVisible: false,
      currentSelectedTabName: 'null',
      currentSelectedDiv: 'null',
      currentTabName: '',
      disabled: false,

      picFilelList: [],
      videoFilelList: [],
      fileFileList: [],
      editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'BulletedList',
          'NumberedList',
          '|',
          'imageUpload',
          'insertTable',
          'mediaEmbed',
          'Undo',
          'Redo',
        ]
      },
      materialTitle: '',
      addMaterialTitle: '添加图文素材',
      showPreview: false,
      previewImageUrl: "",
      articleLinkDrawer: false,
      showUploadBtn: true,
      loadingUpload: false
    }
  },
  props: {
    pathUrl: {
      type: String,
      default() {
        return 'material'
      }
    },
    selectedGroupType: {
      type: String,
      default() {
        return ''
      }
    },
    source: {
      type: String,
      default() {
        return 'material'
      }
    }
  },
  watch: {
    currentMaterialType(type) {
      this.currentMaterialList = [];
      this.searchKeywords = '';
      this.loadMaterialList();
    },
  },
  mounted() {
    this.loadMaterialList();
    this.currentSelectedDiv = 'null'
    console.log('dynameic', this.pathUrl)
  },
  methods: {
    onReady(editor) {
      console.log('12345')
      editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        console.log(new MyUploadAdapter(loader))
        return new MyUploadAdapter(loader);
      }

    },
    doCopy(content) {
      let that = this;
      this.$copyText(content).then(function (e) {
        that.$message({message: '复制成功', type: 'success'});
      }, function (e) {
        alert('您的浏览器不允许复制')
      })
    },
    viewImage(item) {
      console.log(item)
      this.previewImageUrl = item.content.url
      this.showPreview = true
    },
    handleClick() {
      this.articalSearchInput = ''
    },
    beforeUploadPicture(file) {
      console.log(file)
      /* let size=file.size / 1024 / 1024 <=2
            let type =file.type.indexOf('image')!==-1
            if (!type){
                this.$message({
                    message:'只能上传图片',
                    duration:2000,
                    type:'warning'
                })
                return
            }
            if (!size){
                this.$message({
                    message:'上传的图片不能超过2M',
                    duration:2000,
                    type:'warning'
                })
                return
            }
            return type&&size*/
    },
    voiceUploadSuccess(res, file) {
      console.log(res, file)
      this.currentMaterialVoice.content.url = res.url;
      if (this.currentMaterialVoice.content.name === '') {
        this.currentMaterialVoice.content.name = file.name;
      }
      this.currentMaterialVoice.content.size = file.size
      //console.log(this.currentMaterialVoice);
      this.loadingUpload = false
    },
    fileUploadSuccess(res, file) {
      console.log(res, file)
      this.currentMaterialFile.content.url = res.url;
      if (this.currentMaterialFile.content.name === '') {
        this.currentMaterialFile.content.name = file.name;
      }

      this.currentMaterialFile.content.size = file.size
      console.log(this.currentMaterialFile)
      this.loadingUpload = false
    },
    pictureUploadSuccess(res, file) {
      console.log(res, file)
      this.currentMaterialImage.content.url = res.url;
      if (this.currentMaterialImage.content.name === '') {
        this.currentMaterialImage.content.name = file.name;
      }
      this.currentMaterialImage.content.size = file.size
      this.loadingUpload = false
    },
    videoUploadSuccess(res, file) {
      console.log(res, file)
      this.currentMaterialVideo.content.url = res.url;
      if (this.currentMaterialVideo.content.name === '') {
        this.currentMaterialVideo.content.name = file.name;
      }
      this.currentMaterialVideo.content.size = file.size
      this.loadingUpload = false
    },
    imageFileUpload(res, file) {
      this.currentMaterialNews.content.cover = res.url
      this.currentMaterialNews.content.coverSize = file.size
      this.currentMaterialNews.content.ext.name = file.name
      this.loadingUpload = false
    },
    deleteMateria(id, type) {
      let title = ''
      if (type === 'link') {
        title = '此操作将永久删除该图文素材,是否继续?'
      }
      if (type === 'image') {
        title = '此操作将永久删除该图片素材,是否继续?'
      }
      if (type === 'text') {
        title = '此操作将永久删除该文字素材,是否继续?'
      }
      if (type === 'video') {
        title = '此操作将永久删除该视频素材,是否继续?'
      }
      if (type === 'file') {
        title = '此操作将永久删除该文件素材,是否继续?'
      }
      if (type === 'voice') {
        title = '此操作将永久删除该音频素材,是否继续?'
      }
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete('/dryer-api/material/' + id).then(res => {
          this.$message({message: '删除素材成功', type: 'success'});
          this.loadMaterialList();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration: 2000
        });
      });
    },
    openMaterialText(item, type) {
      this.fileList = []
      this.showUploadBtn = false
      console.log(item)
      if (type == 'text') {
        this.currentMaterialText = JSON.parse(JSON.stringify(item));
        this.textDialogVisible = true
        this.materialTitle = '编辑文本素材'
      }
      if (type === 'image') {
        this.currentMaterialImage = JSON.parse(JSON.stringify(item));
        this.pictureDialogVisible = true
        this.materialTitle = '编辑图片素材'
        if (item.content.url !== '') {
          this.fileList.push(item.content)
        }

      }
      if (type === 'video') {
        this.currentMaterialVideo = JSON.parse(JSON.stringify(item));
        this.videoDialogVisible = true
        this.materialTitle = '编辑视频素材'
        if (item.content.url !== '') {
          this.fileList.push(item.content)
        }
      }
      if (type === 'file') {
        this.currentMaterialFile = JSON.parse(JSON.stringify(item));
        this.fileDialogVisible = true
        this.materialTitle = '编辑文件素材'
        if (item.content.url !== '') {
          this.fileList.push(item.content)
        }
      }
      if (type === 'voice') {
        this.currentMaterialVoice = JSON.parse(JSON.stringify(item));
        this.voiceDialogVisible = true
        this.materialTitle = '编辑音频素材'
        if (item.content.url !== '') {
          this.fileList.push(item.content)
        }
      }
    },
    saveCurrentVoice() {
      if (this.currentMaterialVoice.content.name === '') {
        this.$message({
          message: '请填写音频名称',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialVoice.content.url === '') {
        this.$message({
          message: '请选择音频',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialVoice.id == '') {
        this.$http.post('/dryer-api/material/voice', this.currentMaterialVoice.content).then(res => {
          console.debug('create text response', res);
          console.log('create text response', res);
          this.$message({message: '创建音频素材成功', type: 'success'});
          this.loadMaterialList();
          this.voiceDialogVisible = false;
        })
      } else {
        let postVoice = {
          "ext": this.currentMaterialVoice.content.ext,
          "name": this.currentMaterialVoice.content.name,
          "size": this.currentMaterialVoice.content.size,
          "url": this.currentMaterialVoice.content.url
        }
        this.$http.put('/dryer-api/material/voice/' + this.currentMaterialVoice.id, postVoice).then(res => {
          console.debug('update text response', res);
          this.$message({message: '更新音频素材成功', type: 'success'});
          this.voiceDialogVisible = false;
          this.loadMaterialList();
        })
      }
    },
    saveCurrentFile() {
      if (this.currentMaterialFile.content.name === '') {
        this.$message({
          message: '请填写文件名称',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialFile.content.url === '') {
        this.$message({
          message: '请选择文件',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialFile.id == '') {
        this.$http.post('/dryer-api/material/file', this.currentMaterialFile.content).then(res => {
          console.debug('create text response', res);
          this.$message({message: '创建文件素材成功', type: 'success'});
          this.loadMaterialList();
          this.fileDialogVisible = false;
        })
      } else {
        let postData = {
          "ext": this.currentMaterialFile.content.ext,
          "name": this.currentMaterialFile.content.name,
          "size": this.currentMaterialFile.content.size,
          "url": this.currentMaterialFile.content.url
        }
        this.$http.put('/dryer-api/material/file/' + this.currentMaterialFile.id, postData).then(res => {
          console.debug('update text response', res);
          this.$message({message: '更新文件素材成功', type: 'success'});
          this.fileDialogVisible = false;
          this.loadMaterialList();
        })
      }
    },
    saveCurrentVideo() {
      if (this.currentMaterialVideo.content.name === '') {
        this.$message({
          message: '请填写视频名称',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialVideo.content.url === '') {
        this.$message({
          message: '请选择视频',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialVideo.id == '') {
        this.$http.post('/dryer-api/material/video', this.currentMaterialVideo.content).then(res => {
          console.debug('create text response', res);
          this.$message({message: '创建视频素材成功', type: 'success'});
          this.loadMaterialList();
          this.videoDialogVisible = false;
        })
      } else {
        let postData = {
          "cover": this.currentMaterialVideo.content.cover,
          "description": this.currentMaterialVideo.content.description,
          "ext": this.currentMaterialVideo.content.ext,
          "name": this.currentMaterialVideo.content.name,
          "size": this.currentMaterialVideo.content.size,
          "url": this.currentMaterialVideo.content.url
        }
        this.$http.put('/dryer-api/material/video/' + this.currentMaterialVideo.id, postData).then(res => {
          console.debug('update text response', res);
          this.$message({message: '更新视频素材成功', type: 'success'});
          this.videoDialogVisible = false;
          this.loadMaterialList();
        })
      }
    },
    saveCurrentImage() {
      console.log(this.currentMaterialImage)
      if (this.currentMaterialImage.content.name === '') {
        this.$message({
          message: '请填写图片名称',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialImage.content.url === '') {
        this.$message({
          message: '请选择图片',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialImage.id == '') {
        this.$http.post('/dryer-api/material/image', this.currentMaterialImage.content).then(res => {
          console.debug('create text response', res);
          this.$message({message: '创建图片素材成功', type: 'success'});
          this.loadMaterialList();
          this.pictureDialogVisible = false;
          this.fileList = []
        })
      } else {
        let postImage = {
          "ext": this.currentMaterialImage.content.ext,
          "name": this.currentMaterialImage.content.name,
          "size": this.currentMaterialImage.content.size,
          "url": this.currentMaterialImage.content.url
        }
        this.$http.put('/dryer-api/material/image/' + this.currentMaterialImage.id, postImage).then(res => {
          console.debug('update text response', res);
          this.$message({message: '更新图片素材成功', type: 'success'});
          this.loadMaterialList();
          this.pictureDialogVisible = false;
          this.fileList = []
        })
      }
    },
    saveCurrentText() {
      if (this.currentMaterialText.content.content === '') {
        this.$message({
          message: '请填写文本内容',
          type: 'warning',
          duration: 2000
        })
        return
      }
      if (this.currentMaterialText.id == '') {
        this.$http.post('/dryer-api/material/text', this.currentMaterialText.content).then(res => {
          console.debug('create text response', res);
          this.$message({message: '创建文本消息成功', type: 'success'});
          this.loadMaterialList();
          this.currentMaterialText.content = '';
          this.textDialogVisible = false;
        })
      } else {
        this.$http.put('/dryer-api/material/text/' + this.currentMaterialText.id, this.currentMaterialText.content).then(res => {
          console.debug('update text response', res);
          this.$message({message: '更新文本消息成功', type: 'success'});
          this.loadMaterialList();
          this.currentMaterialText.content = '';
          this.textDialogVisible = false;
        })
      }
    },
    saveCurrentNews() {
      console.log(this.currentMaterialNews)
      if (this.currentMaterialNews.content.title === '') {
        this.$message({
          message: '请填写文章标题',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (this.currentMaterialNews.content.author === '') {
        this.$message({
          message: '请填写文章作者',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (this.currentMaterialNews.content.content === '') {
        this.$message({
          message: '请填写文章内容',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (this.currentMaterialNews.content.cover === '') {
        this.$message({
          message: '请选择文章封面图片',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (this.currentMaterialNews.content.summary === '') {
        this.$message({
          message: '请选择文章描述',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (this.currentMaterialNews.id == '') {
        this.$http.post('/dryer-api/material/news', this.currentMaterialNews.content).then(res => {
          console.debug('create news response', res);
          this.$message({message: '创建图文消息成功', type: 'success'});
          this.loadMaterialList();
          this.articleDrawer = false;
        })
      } else {
        this.$http.put('/dryer-api/material/news/' + this.currentMaterialNews.id, this.currentMaterialNews.content).then(res => {
          console.debug('create news response', res);
          this.$message({message: '更新图文消息成功', type: 'success'});
          this.loadMaterialList();
          this.articleDrawer = false;
        })
      }
    },
    aliyunOssRequestMaterialNews(data) {
      let file = data.file;
      console.log(file)
      const fileName = file.name;
      let size = file.size / 1024 / 1024 <= 2
      const fileType = fileName.substring(fileName.lastIndexOf('.'));
      console.log(fileType)
      if (fileType !== '.jpg' && fileType !== '.png' && fileType !== '.JPG' && fileType !== '.PNG') {
        this.$message({
          message: '请选择JPG,PNG格式的图片',
          duration: 2000,
          type: 'warning'
        })
        this.fileList = []
        return
      }
      if (!size) {
        this.$message({
          message: '上传的图片大小不能超过2M',
          type: 'warning',
          duration: 2000
        })
        this.fileList = []
        return
      }
      this.loadingUpload = true
      let res = upload(ossConfig, file);
      console.debug('oss upload res', data, res);
      this.showUploadBtn = false

      return res;

    },
    aliyunOssRequestVoice(data) {
      let file = data.file;
      console.log(file)
      const fileName = file.name;
      const fileType = fileName.substring(fileName.lastIndexOf('.'));
      if (fileType !== '.amr' && fileType !== '.mp3' && fileType !== '.AMR' && fileType !== '.MP3') {
        this.$message({
          message: '请选择AMR,MP3格式的音频',
          duration: 2000,
          type: 'warning'
        })
        this.fileList = []
        return
      }
      console.log(file)
      this.loadingUpload = true
      let res = upload(ossConfig, file);
      console.debug('oss upload res', data, res);
      this.showUploadBtn = false
      return res;
    },
    aliyunOssRequestVideo(data) {
      let file = data.file;
      console.log(file)
      const fileName = file.name;
      const fileType = fileName.substring(fileName.lastIndexOf('.'));
      let size = file.size / 1024 / 1024 <= 10
      if (fileType !== '.mp4' && fileType !== '.MP4') {
        this.$message({
          message: '请选择MP4格式的视频',
          duration: 2000,
          type: 'warning'
        })
        this.fileList = []
        return
      }
      if (!size) {
        this.$message({
          message: '上传的视频素材不能超过10M',
          type: 'warning',
          duration: 2000
        })
        this.fileList = []
        return
      }
      console.log(file)
      this.loadingUpload = true
      let res = upload(ossConfig, file);
      console.debug('oss upload res', data, res);
      this.showUploadBtn = false
      return res;

    },
    aliyunOssRequest(data) {
      let file = data.file;
      console.log(file)
      let size = file.size / 1024 / 1024 <=20
      if (!size){
        this.$message({
          message: '上传的文件素材不能超过20M',
          type: 'warning',
          duration: 2000
        })
        this.fileList = []
        return
      }
      this.loadingUpload = true
      let res = upload(ossConfig, file);
      console.debug('oss upload res', data, res);
      this.showUploadBtn = false
      return res;
    },
    imageLinkUpload(res, file) {
      this.currentMaterialLinkNews.content.cover = res.url
      this.currentMaterialLinkNews.content.coverSize = file.size
    },
    handleChangePic(file, fileList) {
      console.log(fileList)
      if (fileList.length > 1) {
        fileList.splice(0, 1);
        this.fileList = fileList
      }
    },
    loadMaterialList() {
      console.log('res', this.articalSearchInput)
      console.log('type', this.currentMaterialType)
      this.$http.get('/dryer-api/material?type=' + this.currentMaterialType + '&keyword=' + this.articalSearchInput)
          .then(res => {
            console.debug('loadMaterialList res', res);
            console.log('res', res)
            this.currentMaterialList = res.data;
          })
    },
    valueNull() {
      if (this.articalSearchInput === '') {
        this.loadMaterialList()
      }
    },
    changShowOperation(index) {
      this.showTextOperation = index;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = []
      this.currentMaterialImage.content = {
        name: '',
        url: '',
        size: 0,
        ext: {}
      }
      this.currentMaterialVideo.content = {
        name: '',
        url: '',
        description: '',
        size: 0,
        ext: {},
        cover: ''
      }
      this.currentMaterialFile.content = {
        name: '',
        url: '',
        size: 0
      }
      this.currentMaterialVoice.content = {
        name: '',
        url: '',
        description: '',
        size: 0
      }
      this.showUploadBtn = true
    },
    playVideo(url) {
      this.dialogPlay = true;
      this.videoUrl = url;
    },
    closeDialog() {
      this.videoUrl = ""; //清空数据 关闭视频播放
    },
    listenAudio(index) {
      console.log(this.currentMaterialList[index]);
      if (this.playingStutus) {
        this.$message.error('有音频正在播放，请先停止。');
      } else {
        this.audio = new Audio();
        // this.audio.src = 'https://img.tukuppt.com/newpreview_music/08/99/49/5c897788e421b53181.mp3';
        this.audio.src = this.currentMaterialList[index].content.url;
        let playPromise;
        playPromise = this.audio.play();
        let audioPlayButton = document.getElementById(index + 'play')
        audioPlayButton.style.display = 'none';
        let audioStopButton = document.getElementById(index + 'stop')
        audioStopButton.style.display = 'flex';
        this.playingStutus = true;
        let that = this;
        /*  if (playPromise) {
                        playPromise.then(() => {
                            // 音频加载成功
                            // 音频的播放需要耗时
                        that.tiemr = setInterval(() => {
                            second--;
                            if (second <= 0) {
                            that.audio.pause()
                            clearInterval(that.tiemr);
                            }
                        }, 1000);
                        }).catch((e) => {
                        // 音频加载失败
                        console.error(e);
                        });
                    }*/
      }
    },
    stopAudio(index) {
      this.audio.pause();
      let audioPlayButton = document.getElementById(index + 'play')
      console.log(audioPlayButton)
      audioPlayButton.style.display = 'block';
      let audioStopButton = document.getElementById(index + 'stop')
      audioStopButton.style.display = 'none';
      this.playingStutus = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //获取选中id改变index
    groupClick(index, tabName, item) {
      if (this.currentSelectedDiv == item.id) {
        this.currentSelectedDiv = 'null';
        console.log('我取消了', item)
        this.$emit('saveSelectedMaterial', {})
      } else {
        this.currentSelectedDiv = item.id;
        this.currentSelectedTabName = tabName;
        console.log('我是选中了', item)
        this.$emit('saveSelectedMaterial', item)
      }
    },
    //赋值图文链接
    copeUrl(itemUrl, item) {
      console.log(item)
      let that = this;
      let url = process.env.VUE_APP_SCRM_HOST + '/article.html?id=' + item.id
      window.open(url, "_blank")
      /*this.$copyText(url).then(function (e) {
                that.$message({message: '复制成功', type: 'success' });
            }, function (e) {
                alert('您的浏览器不允许复制')
            })*/
      /*this.$copyText(itemUrl).then(function (e) {
                that.$message({message: '复制成功', type: 'success' });
            }, function (e) {
                alert('您的浏览器不允许复制')
            })*/
      /* var input = document.createElement("input");   // js创建一个input输入框
            input.value = this.text;  // 将需要复制的文本赋值到创建的input输入框中
            document.body.appendChild(input);    // 将输入框暂时创建到实例里面
            input.select();   // 选中输入框中的内容
            document.execCommand("Copy");   // 执行复制操作
            document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作*/
    },
    copeLinkUrl(url, item) {
      window.open(url, "_blank")
    },
    //新建图文素材
    openMaterialNews() {
      this.articleDrawer = true
      this.addMaterialTitle = '添加图文素材'
      this.currentMaterialNews = {
        id: '',
        content: {
          author: "",
          content: "",
          cover: "",
          ext: {},
          summary: "",
          title: "",
          coverSize: ''
        }
      }
      this.fileList = []
    },
    //打开图文抽屉
    openarticleDrawer(item) {
      this.addMaterialTitle = '编辑图文素材'
      this.currentMaterialNews = JSON.parse(JSON.stringify(item));
      this.articleDrawer = true
      let info = {}
      this.fileList = []
      info.url = item.content.cover
      if (item.content.ext.name !== undefined) {
        info.name = item.content.ext.name
      }
      if (item.content.cover !== '') {
        this.fileList.push(info)
      }
      console.log('item', item.content.ext.name)
    },
    openMaterialNewsLink() {
      this.articleLinkDrawer = true
      this.addMaterialTitle = '添加外链图文素材'
      this.fileList = []
      this.currentMaterialLinkNews = {
        id: '',
        content: {
          author: "",
          cover: "",
          coverSize: 0,
          summary: "",
          title: "",
          url: ''
        }
      }
    },
    openMaterialNewsLinkDrawer(item) {
      this.articleLinkDrawer = true
      this.addMaterialTitle = '编辑外链图文素材'
      this.currentMaterialLinkNews = JSON.parse(JSON.stringify(item));
      let info = {}
      this.fileList = []
      info.url = item.content.cover
      if (item.content.cover) {
        let name = item.content.cover.substring(item.content.cover.lastIndexOf("/") + 1)
        info.name = name
      }
      if (info.url !== '') {
        this.fileList.push(info)
      }
    },
    //打开新建文本抽屉
    openTextDialog() {
      this.textDialogVisible = true
      this.materialTitle = '新增文本素材'
      this.currentMaterialText = {
        id: '',
        content: {
          content: ''
        }
      }
    },
    openPictureDialog() {
      this.pictureDialogVisible = true
      this.materialTitle = '新增图片素材'
      this.fileList = []
      this.showUploadBtn = true
      this.loadingUpload = false
      this.currentMaterialImage = {
        id: '',
        content: {
          name: '',
          url: '',
          size: 0,
          ext: {}
        }
      }
    },
    openVideoDialog() {
      this.videoDialogVisible = true
      this.materialTitle = '新增图片素材'
      this.fileList = []
      this.showUploadBtn = true
      this.loadingUpload = false
      this.currentMaterialVideo = {
        id: '',
        content: {
          name: '',
          url: '',
          description: '',
          size: 0,
          ext: {},
          cover: ''
        }
      }
    },
    openFileDialog() {
      this.fileDialogVisible = true
      this.materialTitle = '新增文件素材'
      this.fileList = []
      this.showUploadBtn = true
      this.loadingUpload = false
      this.currentMaterialFile = {
        id: '',
        content: {
          name: '',
          url: '',
          size: 0
        }
      }
    },
    openVoiceDialog() {
      this.voiceDialogVisible = true
      this.materialTitle = '新增音频素材'
      this.fileList = []
      this.showUploadBtn = true
      this.loadingUpload = false
      this.currentMaterialVoice = {
        id: '',
        content: {
          name: '',
          url: '',
          description: '',
          size: 0
        }
      }
    },
    //保存外链图文
    saveCurrentNewsLink() {
      var reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])/;
      if (this.currentMaterialLinkNews.content.title === '') {
        this.$message({
          message: '请填写文章标题',
          duration: 2000,
          type: 'warning'
        })
        return
      }

      if (this.currentMaterialLinkNews.content.url === '') {
        this.$message({
          message: '请填写消息链接',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (!reg.test(this.currentMaterialLinkNews.content.url)) {
        this.$message({
          message: '请输入合法的消息链接',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (this.currentMaterialLinkNews.content.cover === '') {
        this.$message({
          message: '请选择文章封面图片',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (this.currentMaterialLinkNews.content.summary === '') {
        this.$message({
          message: '请选择文章描述',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      console.log(this.currentMaterialLinkNews)
      if (this.currentMaterialLinkNews.id == '') {
        this.$http.post('/dryer-api/material/link-news', this.currentMaterialLinkNews.content).then(res => {
          console.debug('create news response', res);
          this.$message({message: '创建外链图文成功', type: 'success'});
          this.loadMaterialList();
          this.articleLinkDrawer = false;
        })
      } else {
        let url = '/dryer-api/material/link-news/' + this.currentMaterialLinkNews.id
        this.$http.put(url, this.currentMaterialLinkNews.content).then(res => {
          console.debug('create news response', res);
          this.$message({message: '更新外链图文成功', type: 'success'});
          this.loadMaterialList();
          this.articleLinkDrawer = false;
        })
      }
    },

  },
};
</script>

<style lang="less">
@import url(./../assets/less/main/common.less);

.addImage {
  .el-upload {
    display: flex;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}

.setWidth {
  width: calc(100vw - 180px);
}

.setHeight {
  height: calc(100vh - 450px) !important;
}

.material-box {

  .material-content {
    background-color: #ffffff;
    margin: 10px 0 0 0;
    padding: 20px;

    .article-box {
      display: flex;
      flex-direction: column;

      .article-box-title {
        max-width: 400px;
      }

      .article-box-content {
        margin-top: 20px;
        padding: 20px 0px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        height: calc(100vh - 260px);
        overflow-x: hidden;
        overflow-y: scroll;
        align-content: flex-start;

        .article-item-add {
          margin: 5px 10px;
          width: 160px;
          height: 200px;
          background-color: #409eff;
          padding: 20px;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          i {
            color: #ffffff;
            font-size: 36px;
          }

          span {
            color: #ffffff;
            margin-top: 10px;
          }
        }

        .article-item {
          margin: 5px 10px;
          width: 200px;
          height: 240px;
          border: 1px solid #d1dfec;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          cursor: pointer;

          .article-item-image {
            height: 100px;

          }

          .article-item-title {
            margin: 5px 10px;
            font-size: 13px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
            height: 40px;
          }

          .article-item-desc {
            margin: 0px 10px;
            color: #909399;
            font-size: 12px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
            height: 50px;
          }

          .article-item-date {
            margin: 10px 10px;
            color: #909399;
            font-size: 12px;
          }

          .article-item-operation {
            z-index: 999;
            background-color: rgba(0, 0, 0, 0.507);
            padding: 10px 10px;
            border-radius: 0px 0px 5px 5px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #d1dfec;
            position: relative;
            bottom: -0px;

            .date {
              width: 50%;
              font-size: 12px;
              color: #ffffff;

            }

            .button {
              cursor: pointer;

              i {
                color: #ffffff;
                cursor: pointer;
                margin-left: 10px;
              }
            }

          }
        }

        .article-item-selected {
          border: 2px solid #409eff;
        }
      }
    }

    .text-box {
      display: flex;
      flex-direction: column;

      .text-box-title {
        max-width: 400px;
      }

      .text-box-content {
        margin-top: 20px;
        padding: 20px 0px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        height: calc(100vh - 260px);
        overflow-x: hidden;
        overflow-y: scroll;
        align-content: flex-start;

        .text-item-add {
          margin: 5px 10px;
          width: 160px;
          height: 200px;
          background-color: #409eff;
          padding: 20px;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          i {
            color: #ffffff;
            font-size: 36px;
          }

          span {
            color: #ffffff;
            margin-top: 10px;
          }
        }

        .text-item-selected {
          border: 2px solid #409eff !important;
        }

        .text-item {
          margin: 5px 10px;
          width: 200px;
          height: 240px;
          border: 1px solid #d1dfec;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .text-item-title {
            margin: 5px 10px;
            font-size: 13px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            line-clamp: 6;
            -webkit-box-orient: vertical;
            height: 200px;
          }

          .text-item-operation {
            z-index: 999;
            background-color: rgba(0, 0, 0, 0.507);
            padding: 10px 10px;
            border-radius: 0px 0px 5px 5px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #d1dfec;
            position: relative;
            bottom: -0px;

            .date {
              width: 50%;
              font-size: 12px;
              color: #ffffff;

            }

            .button {
              cursor: pointer;

              i {
                color: #ffffff;
                cursor: pointer;
                margin-left: 10px;
              }
            }

          }
        }
      }
    }

    // 图片素材
    .picture-box {
      display: flex;
      flex-direction: column;

      .picture-box-title {
        max-width: 400px;
      }

      .picture-box-content {
        margin-top: 20px;
        padding: 20px 0px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        height: calc(100vh - 260px);
        overflow-x: hidden;
        overflow-y: scroll;
        align-content: flex-start;

        .picture-item-add {
          margin: 5px 10px;
          width: 160px;
          height: 200px;
          background-color: #409eff;
          padding: 20px;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          i {
            color: #ffffff;
            font-size: 36px;
          }

          span {
            color: #ffffff;
            margin-top: 10px;
          }
        }

        .picture-item-selected {
          border: 2px solid #409eff !important;
          /* background: #ffffff url('./../../../assets/images/selected.png') no-repeat top right;*/
        }

        .picture-item {
          margin: 5px 10px;
          width: 200px;
          height: 240px;
          border: 1px solid #d1dfec;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .picture-item-image {
            height: 240px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .el-image {
              border-radius: 5px 5px 0 0;
            }

          }

          .picture-item-name {
            margin: 10px 10px 10px 0px;
            padding: 0px 10px;
            font-size: 13px;
            color: dimgray;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .picture-item-operation {
            z-index: 999;
            background-color: rgba(0, 0, 0, 0.507);
            padding: 10px 10px;
            border-radius: 0px 0px 5px 5px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #d1dfec;
            position: relative;
            bottom: -0px;

            .date {
              width: 35%;
              font-size: 12px;
              color: #FFFFFF;

            }

            .button {
              cursor: pointer;

              i {
                color: #ffffff;
                cursor: pointer;
                margin-left: 10px;
              }
            }

          }
        }
      }
    }
  }

  // 添加编辑图文消息
  .template-config {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 20px;
    height: calc(100vh - 80px);
    overflow-y: scroll;
    overflow-x: hidden;

    .template-config-box {
      background-color: #ffffff;
      border-radius: 5px;
      width: 70%;
      padding: 0px 10px;
      overflow: hidden;

      .template-config-title {
        padding: 0px 10px;
        border-bottom: 1px solid #dddddd;
        color: #303133;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .title-text {
          width: 80%;
        }

        .link-title-text {
          width: 100%;
        }

        .author {
          width: 18%;
        }

        .el-input__inner {
          border: none !important;
          color: #2C3138;
          font-size: 16px;
          padding: 0px;
          font-weight: 400;
          padding-right: 45px;
        }
      }

      .template-link {
        margin: 30px 10px 0 10px;
      }

      .template-config-content {
        margin: 20px 10px 10px 10px;
        height: calc(100vh - 330px);

        .ck-content {
          height: calc(100vh - 350px);
        }
      }

      .template-config-other {
        margin: 30px 10px 10px 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .desc {
          width: 100%;

          .el-input__inner {
            padding: 0px 45px 0 15px;
          }

          .el-textarea__inner {
            padding: 0px 45px 0 15px;
          }
        }

        .image {
          width: 100%;
          height: 40px;
          margin-bottom: 8px;
          border: 1px darkgray dashed;
          border-radius: 5px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          .el-upload--picture-card {
            width: 100%;
            height: 41px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            i {
              font-size: 16px;
            }
          }

          .el-upload {
            height: 40px !important;
            line-height: 40px;
          }

          .el-input__inner {
            padding: 0px 15px;
          }
        }
      }
    }

    .template-preview {
      background-color: #ffffff;
      border-radius: 5px;
      width: 320px;
      padding: 10px;
      flex: none;

      #material-right {
        .el-tabs__nav-scroll {
          height: auto !important;
        }
      }

      .template-preview-content {
        width: 316px;
        height: 550px;
        background: url('../assets/images/phone.png') no-repeat;
        background-size: 316px 550px;
        margin-bottom: 60px;

        .template-preview-article-title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 20px 5px;
          margin: 0px 0px 0px 10px;
          transform: scale(0.75, 0.75);
          position: relative;
          top: 40px;

          i {
            width: 3%;
            margin-right: 20px;
          }

          span {
            width: 90%;
            margin-right: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .template-preview-message-content {
          background-color: #ffffff;
          // height: calc(100vh - 100px);
          padding: 20px 15px;
          margin: 0px 0px 0px 0px;
          transform: scale(0.75, 0.75);
          position: relative;
          top: -40px;
          height: 94%;
          overflow-y: auto;
          overflow-x: hidden;

          .push-message-box {
            border-radius: 5px;
            border: 1px solid #dddddd;
            display: flex;
            flex-direction: column;
            width: 100%;

            .image {
              width: 100%;
              height: 120px;
            }

            .title {
              font-size: 16px;
              font-weight: 600;
              padding: 5px 15px;
              word-break: break-all;
            }

            .desc {
              color: gray;
              font-size: 13px;
              padding: 5px 15px;
              word-break: break-all;
            }
          }
        }

        .template-preview-article-content {
          background-color: #ffffff;
          // height: calc(100vh - 100px);
          padding: 20px 15px 20px 30px;
          margin: 0px 0px 0px 0px;
          transform: scale(0.75, 0.75);
          position: relative;
          top: -40px;
          height: 94%;
          overflow-y: auto;
          overflow-x: hidden;

          .article-content-title {
            font-size: 16px;
            font-weight: 500;
            text-align: left;
          }

          .article-content-author {
            font-size: 14px;
            font-weight: 500;
            text-align: left;
            margin: 10px 0px;
            color: darkgray;

            span {
              margin-right: 15px;
            }
          }

          .article-content-body {
            p {
              line-height: 30px;
              /* text-indent:20px;*/
              /*margin-bottom: 10px;*/
            }

            img {
              width: 90%;
            }

            ul li {
              list-style-type: initial;
            }

            ol li {
              list-style-type: decimal;
            }

            .rich-text-li {
              margin-left: 0px !important;
            }
          }
        }

        .card-box {
          background-color: #2C3138;
          border-radius: 10px;
          box-shadow: 0 0 10px #999999;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px;
          margin: 10px 10px 0px 10px;
          transform: scale(0.75, 0.75);
          position: relative;
          top: 30px;
          height: 30%;

          .user-base-info {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            color: #F0D7B1;

            .user-base-info-text {
              display: flex;
              flex-direction: column;

              .name {
                font-size: 24px;
                margin-bottom: 10px;
              }
            }

            .user-base-info-img {
              width: 30%;

              image {
                width: 50px;
                height: 50px;
              }
            }
          }

          .user-more-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-top: 10px;

            .user-more-info-item {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              color: #aeb7bd;
              padding: 4px 0px;
              font-size: 9px;

              i {
                margin-right: 10px;
              }
            }
          }
        }

        .edit-box {
          position: fixed;
          top: 160px;
          right: 0px;
          background-color: #FFFFFF;
          padding: 10px;
          border-radius: 20px 0px 0px 20px;
          display: none;
          flex-direction: row;
          align-items: center;

          i {
            margin-right: 5px;
          }
        }

        .card-operation-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin: 0px 0px 10px 0px;
          padding: 10px;
          background-color: #FFFFFF;
          height: 5%;
          transform: scale(0.75, 0.75);

          .card-operation-item {
            display: flex;
            flex-direction: row;
            margin-left: 10px;
            align-items: center;

            image {
              width: 25px;
              height: 25px;
              border-radius: 50%;
              margin-left: -5px;
              z-index: 2;
            }

            .count {
              background-color: #E9E9EB;
              height: 25px;
              line-height: 25px;
              padding: 0px 10px;
              border-radius: 0px 10px 10px 0px;
              margin-left: -5px;
              z-index: 1;
              color: #B2B2B2;
            }
          }

          .share {
            font-size: 14px;
            color: #0F6EFF;

            button {
              border: #FFFFFF;
              background-color: #0F6EFF;
              color: #FFFFFF;
              display: flex;
              flex-direction: row;
              align-items: center;
              font-size: 14px;
              height: 25px;
              border-radius: none;

              i {
                font-size: 20px;
                margin-right: 5px;
              }
            }

          }
        }

        .chatbot-box {
          display: flex;
          flex-direction: column;
          z-index: 999;
          //background-color: #FFFFFF;
          padding: 5px 20px 20px 20px;
          transform: scale(0.75, 0.75);
          height: 70%;
          position: relative;
          top: -60px;

          .chatbot-title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 0px 0px 10px 0px;
            border-bottom: 1px solid #BCBEC2;
          }

          .chatbot-content {
            margin: 10px 0px;
            height: 66%;
            overflow-y: auto;
            overflow-x: hidden;

            .message-box {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              margin: 10px 0px;

              .chatbot-message {
                background-color: #FFFFFF;
                padding: 10px;
                border: 1px solid #E9E9EB;
                border-radius: 0px 20px 20px 20px;
                max-width: 70vw;
              }
            }

            .message-box-user {
              display: flex;
              flex-direction: row;
              justify-content: flex-end;

              .user-message {
                background-color: #0F6EFF;
                color: #FFFFFF;
                padding: 10px;
                border: 1px solid #E9E9EB;
                border-radius: 20px 0px 20px 20px;
                max-width: 70vw;
              }
            }
          }
        }

        .customer-followup-add {
          position: fixed;
          bottom: 0px;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: #0F6EFF;
          border-radius: 50%;
          padding: 10px;
          width: 30px;
          height: 30px;
          text-align: center;
          z-index: 1000;

          i {
            font-size: 28px;
            color: #FFFFFF;
          }
        }
      }
    }
  }

  .article-template-footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 20px;
    background-color: white;

    .el-button {
      width: 40%;
    }
  }
}

// 图文编辑抽屉
.el-drawer__header {
  margin-bottom: 0px !important;
  border-bottom: none !important;
  padding-bottom: 10px;
}

.file-list-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 10px;

  .file-name {
    text-align: left;
    font-size: 10px;
  }

  .file-status {
    text-align: right;
    margin-left: 20px;
    font-size: 10px;
  }
}

.file-list-box:hover {
  background-color: #dddddd;
  padding: 0px 10px;
  border-radius: 5px;
}

.ck-content {
  word-break: break-all;
  // ul,
  // ol,
  // li {
  //     list-style-type: none;
  // }
  ul {
    display: block !important;
    list-style-type: disc !important;
    margin-block-start: 1em !important;
    margin-block-end: 1em !important;
    margin-inline-start: 0px !important;
    margin-inline-end: 0px !important;
    padding-inline-start: 20px !important;
  }

  ul, ul li {
    list-style-type: disc !important;
  }

  ol {
    display: block !important;
    list-style-type: decimal !important;
    margin-block-start: 1em !important;
    margin-block-end: 1em !important;
    margin-inline-start: 0px !important;
    margin-inline-end: 0px !important;
    padding-inline-start: 20px !important;
  }

  ol, ol li {
    list-style-type: decimal !important;
  }

}

</style>